import Vue from 'vue'
import Router from 'vue-router'

/* Router Modules */
import hospital from './modules/doctor/hospital'
import content from './modules/doctor/content'
import financial from './modules/doctor/financial'
import operation from './modules/doctor/operation'
import userManage from './modules/doctor/user'
import counsel from './modules/doctor/counsel'
import educationManage from './modules/doctor/education'

import accountPatientManage from './modules/patient/account'
import userPatientManage from './modules/patient/user'
import contentPatientManage from './modules/patient/content'

/* Layout */
import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [
    {
        path: '/',
        component: Layout,
        meta: { title: '医院管理' },
        children: [
            {
                path: 'hospital/hospitalList',
                component: () => import('@/views/doctor/hospital/hospitalList'),
                meta: { title: '医院列表' }
            }
        ]
    },
    {
        path: '/login',
        component: () => import('@/views/login/index')
    },
    {
        path: '/videoShow/:videoKey',
        component: () => import('@/views/doctor/videoShow/index')
    },
    hospital,
    content,
    financial,
    operation,
    userManage,
    counsel,
    accountPatientManage,
    userPatientManage,
    contentPatientManage,
    educationManage
]

const createRouter = () =>
    new Router({
        mode: 'hash', // require service support
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRoutes
    })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
